import { Guid } from '@shared/utils/guid.helper';

export class Tag {
  tagId: string;
  name: string;
  description: string;
  customColor?: string;
  class: string;
  isSystemTag: boolean;

  constructor(data: Partial<Tag> = {}) {
    this.tagId = data.tagId ?? Guid.EmptyGuid;
    this.name = data.name ?? '';
    this.description = data.description ?? '';
    this.customColor = data.customColor ?? '';
    this.class = data.class ?? '';
    this.isSystemTag = data.isSystemTag ?? false;
  }
}
